import {
  CandidateVerificationRequestResponseSchema,
  type CandidateEmailLinkRequestDto,
  CandidateContactStatusSchema,
  CandidateContactEmailStatusSchema,
  type CandidateContactEmailRequestDto,
  CandidateEmailLinkResultSchema,
  CandidateSessionResponseSchema,
  type CandidateContactStartDto,
  type CandidateContactPhoneRequestDto,
  type CandidateContactPhoneVerifyDto,
  type CandidateEmailLinkVerifyDto,
  TalentNetworkPhoneSignInResponseSchema,
  type TalentNetworkPhoneSignInRequestDto,
  type TalentNetworkPhoneSignInVerifyDto,
} from "@artha/api-contracts";
import { API_ROUTES } from "@artha/types";
import { apiFetch } from "@/lib/apiClient";
import { getApiError, unwrap } from "./personalizationClient";

async function requestContactVerification(path: string, input: unknown) {
  const response = await apiFetch<unknown>(path, {
    method: "POST",
    body: JSON.stringify(input),
  });
  if (!response.ok)
    throw getApiError(
      response.data,
      "Unable to complete verification. Please try again.",
    );
  return unwrap(response.data);
}

export const startCandidateContactVerification = async (
  username: string,
  input: CandidateContactStartDto,
) =>
  CandidateContactStatusSchema.parse(
    await requestContactVerification(
      API_ROUTES.CANDIDATE_CONTACT.START(username),
      input,
    ),
  );

export const requestCandidateContactEmailLink = async (
  username: string,
  input: CandidateContactEmailRequestDto,
) =>
  CandidateContactEmailStatusSchema.parse(
    await requestContactVerification(
      API_ROUTES.CANDIDATE_CONTACT.EMAIL_RESEND(username),
      input,
    ),
  );

export const verifyCandidateEmailLink = async (
  username: string,
  input: CandidateEmailLinkVerifyDto,
) =>
  CandidateEmailLinkResultSchema.parse(
    await requestContactVerification(
      API_ROUTES.CANDIDATE_CONTACT.EMAIL_VERIFY(username),
      input,
    ),
  );

export const requestCandidatePhoneCode = async (
  username: string,
  input: CandidateContactPhoneRequestDto,
) =>
  requestContactVerification(
    API_ROUTES.CANDIDATE_CONTACT.PHONE_REQUEST(username),
    input,
  );

export const verifyCandidatePhoneCode = async (
  username: string,
  input: CandidateContactPhoneVerifyDto,
) =>
  CandidateSessionResponseSchema.parse(
    await requestContactVerification(
      API_ROUTES.CANDIDATE_CONTACT.PHONE_VERIFY(username),
      input,
    ),
  );

export const requestCandidateSignInLink = async (
  input: CandidateEmailLinkRequestDto,
) =>
  CandidateVerificationRequestResponseSchema.parse(
    await requestContactVerification(
      API_ROUTES.CANDIDATE_CONTACT.EMAIL_REQUEST,
      input,
    ),
  );

export const requestTalentNetworkPhoneSignIn = async (username: string, input: TalentNetworkPhoneSignInRequestDto) =>
  TalentNetworkPhoneSignInResponseSchema.parse(await requestContactVerification(API_ROUTES.TALENT_NETWORK.SIGN_IN_REQUEST(username), input));

export const verifyTalentNetworkPhoneSignIn = async (username: string, input: TalentNetworkPhoneSignInVerifyDto) =>
  CandidateSessionResponseSchema.parse(await requestContactVerification(API_ROUTES.TALENT_NETWORK.SIGN_IN_VERIFY(username), input));
